import { NavLink } from 'react-router-dom';
import { useStore } from '../store';
import { useSeasonYears } from '../hooks/useSeasonYears';
import { SidebarBrand } from './SidebarBrand';

/* ── Icon SVGs (inline, tiny) ──────────────────── */

function IconDashboard() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  );
}

function IconCalendar() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function IconRaces() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 3h10l4 4v14H5z" />
      <path d="M15 3v4h4" />
      <path d="M8 11h8" />
      <path d="M8 15h6" />
    </svg>
  );
}

function IconStandings() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21v-6M12 21V9M16 21v-4M4 21h16" />
    </svg>
  );
}

function IconConstructors() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
      <path d="M12 2L2 7l10 5 10-5L12 2z" />
    </svg>
  );
}

function IconCircuits() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3c2.5 3 4 6.5 4 9s-1.5 6-4 9" />
      <path d="M12 3c-2.5 3-4 6.5-4 9s1.5 6 4 9" />
      <line x1="3" y1="12" x2="21" y2="12" />
    </svg>
  );
}

function IconH2H() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 3h5v5" />
      <path d="M8 3H3v5" />
      <path d="M21 3l-7 7" />
      <path d="M3 3l7 7" />
      <path d="M3 21l7-7" />
      <path d="M21 21l-7-7" />
    </svg>
  );
}

function IconTeammates() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="7" r="4" />
      <circle cx="15" cy="7" r="4" />
      <path d="M3 21v-2a4 4 0 014-4h2" />
      <path d="M21 21v-2a4 4 0 00-4-4h-2" />
    </svg>
  );
}

function IconTitleFights() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

function IconEras() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

function IconLapTimes() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  );
}

function IconRecords() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 010-5C7 4 7 7 7 7" />
      <path d="M18 9h1.5a2.5 2.5 0 000-5C17 4 17 7 17 7" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20 17 22" />
      <path d="M18 2H6v7a6 6 0 0012 0V2z" />
    </svg>
  );
}

function IconAnalytics() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
      <polyline points="7.5 4.21 12 6.81 16.5 4.21" />
      <polyline points="7.5 19.79 7.5 14.6 3 12" />
      <polyline points="21 12 16.5 14.6 16.5 19.79" />
      <line x1="12" y1="22" x2="12" y2="17" />
      <line x1="12" y1="12" x2="12" y2="7" />
    </svg>
  );
}

function IconPredictor() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 20h20" />
      <path d="M5 20V9l3-3 4 4 4-6 3 3v13" />
    </svg>
  );
}

function IconChampionship() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20v-6" />
      <path d="M12 14c-3.5 0-7-1.5-7-5 0-1.5.5-3 2-4l2.5 3h5L17 5c1.5 1 2 2.5 2 4 0 3.5-3.5 5-7 5z" />
      <circle cx="12" cy="4" r="1" />
    </svg>
  );
}

function IconWhatIf() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 3h8" />
      <path d="M10 3v4" />
      <path d="M14 3v4" />
      <path d="M7 11h10" />
      <path d="M12 11v10" />
      <path d="M8 21h8" />
      <path d="M8 7l-3 4 3 10" />
      <path d="M16 7l3 4-3 10" />
    </svg>
  );
}

function IconNews() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2" />
      <path d="M18 14h-8" />
      <path d="M15 18h-5" />
      <path d="M10 6h8v4h-8V6z" />
    </svg>
  );
}

function IconPolls() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 5h16" />
      <path d="M4 12h10" />
      <path d="M4 19h6" />
      <circle cx="18" cy="5" r="2" />
      <circle cx="16" cy="12" r="2" />
      <circle cx="12" cy="19" r="2" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

function IconMethodology() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 4.5A2.5 2.5 0 0 1 7.5 2H20v18H7.5A2.5 2.5 0 0 0 5 22z" />
      <path d="M5 4.5V22" />
      <path d="M9 6h7" />
      <path d="M9 10h7" />
      <path d="M9 14h5" />
    </svg>
  );
}

function IconMenu() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="18" x2="20" y2="18" />
    </svg>
  );
}

/* ── Navigation Structure ──────────────────── */

interface NavItem {
  label: string;
  to: string;
  icon: React.ReactNode;
}

interface NavGroup {
  label: string;
  items: NavItem[];
}

function buildNavGroups(currentSeasonYear: number, activeSeasonYear: number): NavGroup[] {
  return [
    {
      label: 'Core',
      items: [
        { label: 'Dashboard', to: '/dashboard', icon: <IconDashboard /> },
        { label: 'Calendar', to: `/calendar/${currentSeasonYear}`, icon: <IconCalendar /> },
        { label: 'Races', to: `/races/${currentSeasonYear}`, icon: <IconRaces /> },
        { label: 'Standings', to: `/standings/${activeSeasonYear}`, icon: <IconStandings /> },
      ],
    },
    {
      label: 'Explore',
      items: [
        { label: 'Constructors', to: '/constructors', icon: <IconConstructors /> },
        { label: 'Circuits', to: '/circuits', icon: <IconCircuits /> },
      ],
    },
    {
      label: 'Insights',
      items: [
        { label: 'Head to Head', to: '/h2h', icon: <IconH2H /> },
        { label: 'Teammates', to: '/teammates', icon: <IconTeammates /> },
        { label: 'Title Fights', to: '/title-fights', icon: <IconTitleFights /> },
        { label: 'Eras', to: '/eras', icon: <IconEras /> },
        { label: 'Lap Times', to: '/lap-times', icon: <IconLapTimes /> },
        { label: 'Records', to: '/records', icon: <IconRecords /> },
      ],
    },
    {
      label: 'Intelligence',
      items: [
        { label: 'Analytics', to: '/analytics', icon: <IconAnalytics /> },
        { label: 'Predictions', to: '/predictions', icon: <IconPredictor /> },
        { label: 'Championship', to: '/championship', icon: <IconChampionship /> },
        { label: 'What If', to: '/what-if', icon: <IconWhatIf /> },
      ],
    },
    {
      label: 'Live',
      items: [
        { label: 'Polls', to: '/polls', icon: <IconPolls /> },
        { label: 'News', to: '/news', icon: <IconNews /> },
      ],
    },
  ];
}

/* ── Sidebar Content (shared between desktop & mobile drawer) ── */

function SidebarContent({ onNavigate }: { onNavigate?: () => void }) {
  const setPaletteOpen = useStore((s) => s.setPaletteOpen);
  const { currentSeasonYear, activeSeasonYear } = useSeasonYears();
  const navGroups = buildNavGroups(currentSeasonYear, activeSeasonYear);

  return (
    <>
      <SidebarBrand onNavigate={onNavigate} />

      {/* Navigation groups */}
      <nav>
      {navGroups.map((group) => (
          <div key={group.label} className="sidebar-section">
            <div className="sidebar-section-label">{group.label}</div>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `sidebar-link${isActive ? ' active' : ''}`
                }
                onClick={onNavigate}
              >
                <span className="sidebar-link-icon">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <button
          className="sidebar-footer-btn"
          onClick={() => setPaletteOpen(true)}
        >
          <span className="sidebar-link-icon"><IconSearch /></span>
          <span>Search</span>
          <kbd className="sidebar-kbd">{typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent) ? '⌘K' : 'Ctrl+K'}</kbd>
        </button>
        <NavLink to="/methodology" className="sidebar-footer-link" onClick={onNavigate}>
          <span className="sidebar-link-icon"><IconMethodology /></span>
          <span>Methodology</span>
        </NavLink>
        <div className="sidebar-credit">
          Data: {' '}
          <a href="https://api.jolpi.ca" target="_blank" rel="noopener">Jolpica</a> {'|'}{' '}
          <a href="https://openf1.org" target="_blank" rel="noopener">OpenF1</a> {'|'}{' '}
          <a href="https://www.fia.com" target="_blank" rel="noopener">FIA</a> {'|'}{' '}
          <a href="https://theoehrly.github.io/Fast-F1/" target="_blank" rel="noopener">FastF1</a>
        </div>
      </div>
    </>
  );
}

/* ── Sidebar Component ──────────────────── */

export function Sidebar() {
  const sidebarOpen = useStore((s) => s.sidebarOpen);
  const setSidebarOpen = useStore((s) => s.setSidebarOpen);

  const closeDrawer = () => setSidebarOpen(false);

  return (
    <>
      {/* Hamburger – outside <aside> so it stays visible when sidebar is hidden on phones */}
      <button
        className="hamburger-btn"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open navigation"
      >
        <span className="sidebar-link-icon"><IconMenu /></span>
      </button>

      {/* Desktop sidebar / tablet slim rail */}
      <aside className="sidebar">
        <SidebarContent />
      </aside>

      {/* Mobile drawer */}
      <div
        className={`mobile-drawer-backdrop${sidebarOpen ? ' open' : ''}`}
        onClick={closeDrawer}
        aria-hidden={!sidebarOpen}
      />
      <div
        className={`mobile-drawer${sidebarOpen ? ' open' : ''}`}
        aria-hidden={!sidebarOpen}
        inert={!sidebarOpen ? true : undefined}
      >
        <SidebarContent onNavigate={closeDrawer} />
      </div>
    </>
  );
}
